import { useQuery } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';
import type { Evento } from '../types';

export interface EventoGlobal extends Evento {
  empresa_id: string;
  empresa_nome: string;
  contato_id?: string;
  oportunidade_id?: string;
}

interface EventosFilter {
  tipo?: string;
  canal?: string;
  since?: string;
  empresa_id?: string;
  limit?: number;
}

export function useEventosGlobal(filter: EventosFilter = {}) {
  const params = new URLSearchParams();
  if (filter.tipo) params.set('tipo', filter.tipo);
  if (filter.canal) params.set('canal', filter.canal);
  if (filter.since) params.set('since', filter.since);
  if (filter.empresa_id) params.set('empresa_id', filter.empresa_id);
  if (filter.limit) params.set('limit', String(filter.limit));
  const qs = params.toString();
  return useQuery({
    queryKey: ['eventos-global', filter],
    queryFn: () => n8nFetch<EventoGlobal[]>(`/eventos${qs ? `?${qs}` : ''}`),
  });
}
